import { createContext, useContext } from 'react';

// 다크/라이트 테마 토글 컨텍스트. Provider 는 main.jsx 의 Root 가 담당.
export const ColorModeContext = createContext({ mode: 'dark', toggle: () => {} });
export const useColorMode = () => useContext(ColorModeContext);
